import React from 'react';
import {useTranslation} from '../../../hooks/useTranslation';
import { useSelector } from 'react-redux';

const EquipmentTabHeader = ({
  currentTab,
  changeTab,
  setCurrentPage,
  getEquipment,
  filters,
  debouncedSearchValue
}) => {
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const {t} = useTranslation();
  const handleTabClick = (tabId, tabConfig) => {
    changeTab(tabId);
    setCurrentPage(1);
    
    const queryParams = {
      page: 1,
      equipment_type_id: filters.equipment_type_id || null,
      facility_id: filters.facility_id || null,
      search: debouncedSearchValue || null,
      ...tabConfig
    };
    
    getEquipment(queryParams);
  };

  return (
    <div className='equipment__header'>
      <div
        className={`equipment__header-tab ${currentTab === 0 ? 'active' : ''}`}
        onClick={() => handleTabClick(0, { active: 'true' })}
      >
        {t('equipmentTabs.active')}
      </div>
      <div
        className={`equipment__header-tab ${currentTab === 1 ? 'active' : ''}`}
        onClick={() => handleTabClick(1, { active: 'false' })}
      >
        {t('equipmentTabs.decommissioned')}
      </div>
      <div
        className={`equipment__header-tab ${currentTab === 2 ? 'active' : ''}`}
        onClick={() => handleTabClick(2, { archived: 'true' })}
      >
        {t('equipmentTabs.archived')}
      </div>
      <>
        {
          userInfo?.is_corporate && (
            <div
            className={`equipment__header-tab ${currentTab === 3 ? 'active' : ''}`}
            onClick={() => handleTabClick(3, { transfers: 'true' })}
          >
            {t('equipmentTabs.transfers')}
          </div>
        )}
      </>
    </div>
  );
};

export default EquipmentTabHeader;
